import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

const skipValidation =
  !!process.env.SKIP_ENV_VALIDATION &&
  process.env.SKIP_ENV_VALIDATION !== 'false' &&
  process.env.SKIP_ENV_VALIDATION !== '0';

export const env = createEnv({
  skipValidation,
  server: {
    ANALYZE: z.string().nullish(),
    ZAPIER_GET_AN_ESTIMATE_FORM_WEBHOOK: z.string(),
    ZAPIER_COMPETITOR_REPORT_REQUEST_WEBHOOK: z.string().url(),
    RECAPTCHA_SITE_KEY: z.string(),
    RECAPTCHA_SECRET_KEY: z.string(),
    // mux video
    MUX_TOKEN_ID: z.string(),
    MUX_TOKEN_SECRET: z.string(),
  },
  client: {
    NEXT_PUBLIC_APP_URL: z.string().url(),
    NEXT_PUBLIC_ENVIRONMENT: z.union([z.literal('DEV'), z.literal('PROD')]).nullish(),
    NEXT_PUBLIC_STORYBLOK_PREVIEW_TOKEN: z.string(),
    NEXT_PUBLIC_STORYBLOK_EXCLUDED_FOLDERS_FROM_ROUTING: z.string(),
    NEXT_PUBLIC_STORYBLOK_MAIN_APP_FOLDER: z.string(),
    NEXT_PUBLIC_STORYBLOK_TOKEN_VERSION: z
      .union([z.literal('draft'), z.literal('published')])
      .nullish(),
  },
  runtimeEnv: {
    ANALYZE: process.env.ANALYZE,
    NEXT_PUBLIC_APP_URL: process.env.NEXT_PUBLIC_APP_URL,
    NEXT_PUBLIC_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
    NEXT_PUBLIC_STORYBLOK_TOKEN_VERSION: process.env.NEXT_PUBLIC_STORYBLOK_TOKEN_VERSION,
    NEXT_PUBLIC_STORYBLOK_PREVIEW_TOKEN: process.env.NEXT_PUBLIC_STORYBLOK_PREVIEW_TOKEN,
    NEXT_PUBLIC_STORYBLOK_MAIN_APP_FOLDER: process.env.NEXT_PUBLIC_STORYBLOK_MAIN_APP_FOLDER,
    NEXT_PUBLIC_STORYBLOK_EXCLUDED_FOLDERS_FROM_ROUTING:
      process.env.NEXT_PUBLIC_STORYBLOK_EXCLUDED_FOLDERS_FROM_ROUTING,
    ZAPIER_GET_AN_ESTIMATE_FORM_WEBHOOK: process.env.ZAPIER_GET_AN_ESTIMATE_FORM_WEBHOOK,
    ZAPIER_COMPETITOR_REPORT_REQUEST_WEBHOOK: process.env.ZAPIER_COMPETITOR_REPORT_REQUEST_WEBHOOK,
    RECAPTCHA_SECRET_KEY: process.env.RECAPTCHA_SECRET_KEY,
    RECAPTCHA_SITE_KEY: process.env.RECAPTCHA_SITE_KEY,
    // mux video
    MUX_TOKEN_ID: process.env.MUX_TOKEN_ID,
    MUX_TOKEN_SECRET: process.env.MUX_TOKEN_SECRET,
  },
});
